const $Navigation2AMenuTrigger = $('.js-menu-trigger', '.component-navigation-2A');
const $Navigation2AMenuItemContentTrigger = $('.js-menu-item-content-trigger', '.component-navigation-2A');

const Navigation2A = document.getElementsByClassName('component-navigation-2A--state')[0];
const Navigation2ATop = document.getElementsByClassName('component-navigation-2A__top')[0];
const Navigation2ABottom = document.getElementsByClassName('component-navigation-2A__bottom')[0];

if (Navigation2A && Navigation2ATop && Navigation2ABottom) {
    let Navigation2AIsPastTop = false;
    let Navigation2AIsPastBottom = false;
    let Navigation2ABottomObserver;

    //1. Observer for Point A (Start Sticky)
    const topObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            Navigation2AIsPastTop = !entry.isIntersecting && entry.boundingClientRect.y < 0;
            Navigation2AUpdateNavState();
        });
    });
    topObserver.observe(Navigation2ATop);
    
    // 2. Function to build the bottom observer
    function Navigation2ACreateBottomObserver() {
        // Clear out the old observer if it exists
        if (Navigation2ABottomObserver) {
            Navigation2ABottomObserver.disconnect();
        }

        const Navigation2AHeight = Navigation2A.offsetHeight;

        Navigation2ABottomObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                Navigation2AIsPastBottom = !entry.isIntersecting && entry.boundingClientRect.y <= (Navigation2AHeight + 2);
                Navigation2AUpdateNavState();
            });
        }, {
            // Set the new margin based on the fresh height
            rootMargin: `-${Navigation2AHeight}px 0px 0px 0px` 
        });
        
        Navigation2ABottomObserver.observe(Navigation2ABottom);
    }

    // Initialize the bottom observer on page load
    Navigation2ACreateBottomObserver();

    // 3. ResizeObserver to catch display: none -> display: block changes
    const resizeObserver = new ResizeObserver(() => {
        // Force a manual check of the top trigger. This catches the layout shift 
        // if the trigger was already scrolled past while the nav was hidden.
        Navigation2AIsPastTop = Navigation2ATop.getBoundingClientRect().y < 0;
        
        Navigation2ACreateBottomObserver();
        Navigation2AUpdateNavState();
    });
    resizeObserver.observe(Navigation2A);

    // 4. Central Logic for the Nav State
    function Navigation2AUpdateNavState() {
         // Safeguard: If the nav is hidden on mobile, strip sticky classes and stop
        if (Navigation2A.offsetHeight === 0) {
            Navigation2A.classList.remove('is-sticky', 'is-hidden');
            return;
        }

        if (!Navigation2AIsPastTop) {
            // Zone 1: Above Point A (Normal flow)
            Navigation2A.classList.remove('is-sticky', 'is-hidden');
            
        } else if (Navigation2AIsPastTop && !Navigation2AIsPastBottom) {
            // Zone 2: Between Point A and Point B (Strictly Sticky)
            Navigation2A.classList.add('is-sticky');
            Navigation2A.classList.remove('is-hidden');
            
        } else if (Navigation2AIsPastBottom) {
            // Zone 3: Below Point B (Inactive/Hidden)
            Navigation2A.classList.remove('is-sticky');
            Navigation2A.classList.add('is-hidden');
        }
    }
}

$Navigation2AMenuTrigger.on('click', function() {
    var $navigation = $(this).parents('.component-navigation-2A');
    var $subnavigation = $('.component-navigation-2A__sub-navigation', $navigation);
    var height = $('.component-navigation-2A__sub-navigation-blocks', $navigation).outerHeight(true);
    
    if (!$navigation.is('.active')) {
        $navigation.addClass('active');
        $subnavigation.slideDown('slow');
    } else {
        $navigation.removeClass('active');
        $subnavigation.slideUp('slow');
    }
});

$Navigation2AMenuItemContentTrigger.on('click', function() {
    var $that = $(this);
    var $SubNavigation = $that.parents('.component-navigation-2A__sub-navigation');
    var $SubNavigationBlock = $that.parents('.component-navigation-2A__sub-navigation-block');
    var $SubNavigationTopLevelItemContent = $SubNavigationBlock.find('.component-navigation-2A__sub-navigation-top-level-item-content');// $that.next('.component-navigation-2A__sub-navigation-top-level-item-content');
    var $SubNavigationTopLevelItemContentInnerContainer = $('.component-navigation-2A__sub-navigation-top-level-item-content-inner-container', $SubNavigationTopLevelItemContent);
    var height = $SubNavigationTopLevelItemContentInnerContainer.outerHeight(true);
    
    if ($SubNavigationBlock.is('.active')) {
        $SubNavigationBlock.removeClass('active')
        $SubNavigationTopLevelItemContent.height(0);
    } else {
        $('.component-navigation-2A__sub-navigation-block', $SubNavigation).removeClass('active');
        $('.js-menu-item-content-trigger', $SubNavigation).removeClass('active');
        $('.component-navigation-2A__sub-navigation-top-level-item-content', $SubNavigation).height(0);
        
        $SubNavigationBlock.addClass('active');
        $SubNavigationTopLevelItemContent.height(height);
    }
});